module.exports = __webpack_public_path__ + "static/media/top.b3322910.jpeg";